const DriverList = {
  GET_DRIVER_LIST: '/driver/list',
};
export default DriverList;
